module.exports = __webpack_public_path__ + "img/logo-touch-express.d5e63167.svg";